// src/features/dashboard/utils/productivityChart.utils.ts

/**
 * Get Tooltip Label
 */
export const getLabel = (
  dataKey: string,
) => {

  switch (dataKey) {

    case 'productive':

      return 'Productive %';

    case 'neutral':

      return 'Neutral %';

    case 'idle':

      return 'Idle / Away %';

    default:

      return dataKey;
  }
};

/**
 * Label Style
 */
export const labelStyle = {

  fill: '#FFFFFF',

  fontSize: 11,

  fontWeight: 700,
};